<template lang="pug">
    v-content
        v-container.bg(fluid fill-height)
            v-layout(align-center justify-center)
                v-flex(xs12 sm8 md6 lg4)
                    LoginCard
</template>

<script>
import LoginCard from "../components/LoginCard.vue";
export default {
  components: {
    LoginCard
  }
};
</script>

<style>
.bg {
  background: url("../assets/bg-login_bib.png");
  background-size: cover;
}
</style>


